import React from 'react'

function MenuItem2(props) {
    return (
      <div className="col-lg-6 menu-item">
        <img src={props.img} className="menu-img" alt="Old Tbilisi dish"/>
        <div className="menu-content">
          {props.name}<span>€ {props.price}</span>                   
        </div>
        <div className="menu-ingredients">
          {props.desc}
        </div>
        <hr></hr>
      </div>      
    )
}

export default MenuItem2;
